module.exports = ['$scope', 'railsResource', function ($scope, $resource) {
  const AssetClass = $resource('/asset_classes/:id', { id: '@id' });
  this.assetClasses = AssetClass.query({ include_bac_allocations: true });
  this.editingAssetClass = null;

  this.edit = (assetClass) => {
    if (this.hasNew()) this.assetClasses.shift();
    this.editingAssetClass = assetClass;
  };

  this.isEditing = (assetClass) => this.editingAssetClass && this.editingAssetClass.id === assetClass.id;

  this.hasNew = () => _.some(this.assetClasses, ac => !ac.id);

  this.new = () => {
    if (this.hasNew()) return;

    const newAssetClass = { name: '', description: '' };
    this.assetClasses.unshift(newAssetClass);
    this.editingAssetClass = newAssetClass;
  };

  this.save = (assetClass) => {
    this.editingAssetClass = null;
    if (assetClass.id) {
      AssetClass.update({
        id: assetClass.id,
        name: assetClass.name,
        description: assetClass.description,
      }).$promise
        .then(updatedAssetClass => this.refreshAssetClass(assetClass, updatedAssetClass));
    } else {
      AssetClass.create(assetClass).$promise
        .then(newAssetClass => this.refreshAssetClass(assetClass, newAssetClass));
    }
  };

  this.refreshAssetClass = (originalAssetClass, newAssetClass) => {
    AssetClass.get({ id: newAssetClass.id, include_bac_allocations: true }).$promise
      .then(getAssetClass => {
        const assetClassIdx = _.indexOf(this.assetClasses, originalAssetClass);
        this.assetClasses[assetClassIdx] = getAssetClass;
      });
  };

  this.delete = (assetClass) => {
    if (assetClass.id) {
      assetClass.$delete().then(() => {
        _.remove(this.assetClasses, assetClass);
      });
    }
  };

  this.cancel = () => {
    if (this.hasNew()) this.assetClasses.shift();
    this.editingAssetClass = null;
  };
}];
